import * as React from "react";
import * as styles from "./styles.module.scss";
import { CuriosityProps } from "./types";
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

const Curiosity: React.FC<CuriosityProps> = ({ item }: CuriosityProps) => {
  const { title, text } = item;

  return (
    <AccordionItem>
      <AccordionItemHeading>
        <AccordionItemButton>{title}</AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <p dangerouslySetInnerHTML={{ __html: text }} />
      </AccordionItemPanel>
    </AccordionItem>
  );
};

export default Curiosity;
